import { ActivatedRoute, Router } from '@angular/router';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NotificationContext, NotificationContextHelper } from 'src/app/helper/notification-context.helper';
import { ConfirmationDialogService } from './../../../confirmation-dialog/confirmation-dialog.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpService } from 'src/app/services/http.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { URLUtils } from 'src/app/urlUtils';
import { environment } from 'src/environments/environment';
import { ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ShareDocumentsDialogComponent } from './share-documents-dialog/share-documents-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-relationship-exchange',
    templateUrl: 'relationship-exchange.component.html',
    styleUrls: ['relationship-exchange.component.scss'],
    standalone: false
})
export class RelationshipExchangeComponent implements OnInit {

    @ViewChildren('docRow') docRows!: QueryList<ElementRef<HTMLTableRowElement>>;
    @Input() reldata: any = {};
    @Input() activeTab: any;
    @Input() relType: any;
    @Input() showExchange: any;
    @Output() event = new EventEmitter<string>();
    relname: string = "";
    isDesc: boolean = false;
    profileInfo: any;
    searchText: any = '';
    currentTab: string = 'profile';
    currentInnerTab: string = 'sharedwithus';
    docsSharedwithus: any;
    docsSharedbyus: any = [];
    urlSafe: any;
    viewClientDocuments: boolean = true;
    viewFirmDocuments: boolean = false;
    clientDocuments: any = [];
    firmDocuments: any = [];
    allDocs: any = [];
    searchDocText: string = '';
    openconfirmationunmodifiedDoc: boolean = true;
    openconfirmationAddedDoc: boolean = true;
    openconfirmationRemovedDoc: boolean = true;
    viewSharedDoc: boolean = true;
    clientandfirmviewexpanded: boolean = false;
    sharedandUnsharedData: any = { 'add': [], 'remove': [], 'message': "" };
    isConformation: boolean = false;
    unchangedDocs: any = [];
    message: string = '';
    isEntityProfile: boolean = false;
    sharedIds: string[] = [];
    unsharedIds: string[] = [];
    clientId: string = "";
    grp_acls:any[]=[];
    isReverse:boolean=false;
    documents: any = [];
    showview: boolean = false;
    product= environment.product;
    category: any;
    matterList:any[]=[]; 
    highlightSet = new Set<string>();
    allowedFileTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/rtf','text/csv','text/rtf','rtf'];
    
    selectedProfile: any;
    connectionKey = false;
    profileKey = false;
    private allDocuments: Document[] = [];
    pageSize = 10;
    currentPage = 0;
    totalDocuments = 0;
    showDetails = false;

    selectedCountry: any
    countryCodeMap: { [key: string]: string } = {
        "Argentina": "ar",
        "Australia": "au",
        "Austria": "at",
        "Belgium": "be",
        "Bosnia": "ba",
        "Brazil": "br",
        "Bulgaria": "bg",
        "Canada": "ca",
        "Chile": "cl",
        "China": "cn",
        "Croatia": "hr",
        "Czech Republic": "cz",
        "Denmark": "dk",
        "Estonia": "ee",
        "Finland": "fi",
        "France": "fr",
        "Germany": "de",
        "Herzegovina": "ba", // Bosnia and Herzegovina use the same code
        "Iceland": "is",
        "India": "in",
        "Indonesia": "id",
        "Israel": "il",
        "Italy": "it",
        "Latvia": "lv",
        "Lithuania": "lt",
        "Macedonia": "mk",
        "Malaysia": "my",
        "Mexico": "mx",
        "Moldova": "md",
        "Montenegro": "me",
        "Netherlands": "nl",
        "New Zealand": "nz",
        "Norway": "no",
        "Poland": "pl",
        "Portugal": "pt",
        "Romania": "ro",
        "Serbia": "rs",
        "Singapore": "sg",
        "Slovakia": "sk",
        "Slovenia": "si",
        "South Africa": "za",
        "South Korea": "kr",
        "Spain": "es",
        "Sweden": "se",
        "Switzerland": "ch",
        "Turkey": "tr",
        "Ukraine": "ua",
        "United Arab Emirates": "ae",
        "United Kingdom": "gb",
        "United States": "us",
        "USA": "us"
    };
    citizen: any[] = [];
    country: any;
    filesSharedWith: any[] = [];
    filesSharedBy: any[] = [];
    files: any[] = [];
    activeTol: 'by' | 'with' = 'by'; // default to "Share By Me"
    isLoading = false;
    previewDocument: any;
    isPreviewOpen = false;
    isShareDialogOpen = false;
    isAccepted=false;

    readonly IMAGE_MIME_TYPES = new Set([
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'image/webp',
        'image/bmp',
        'image/tiff',
        'image/x-icon'
    ]);
    selectedDoc: any = null;
    selectedType: string = '';
    docapi = environment.doc2pdf;


    constructor(private formBuilder: FormBuilder,
        private httpService: HttpService,private dialog: MatDialog,
        private confirmationDialogService: ConfirmationDialogService,
        private sanitizer: DomSanitizer,
        private aroute: ActivatedRoute,
        private toast: ToastrService,
        private router: Router,
        public spinnerService :NgxSpinnerService) {
    }

    ngOnInit() { 
        //console.log('Relationship Data:', this.reldata);

        this.isAccepted = this.reldata.isAccepted;
        //console.log('isacc',this.isAccepted)
        
        const ctx = NotificationContextHelper.consume();
        if (ctx) {
          this.handleNotificationFlow(ctx);
        } 
         
        if (this.reldata?.tab)
            this.currentTab = this.reldata?.tab

        const allowed = new Set(['entity', 'corporate']);
        this.clientId = this.reldata['client_id']
       // this.grp_acls = this.reldata.groups.map((obj: any) => { return obj.id })
        allowed.has(this.reldata.clientType.toLowerCase()) ? this.isEntityProfile = true : this.isEntityProfile = false;

        this.matterList = this.reldata?.matterList
        if ((this.activeTab == 'corporate' || this.activeTab == 'marketplace') || environment.product == 'corporate') {
            this.httpService.sendGetRequest(URLUtils.relationshipExchangeInfoProfileCorp(this.reldata)).subscribe((res: any) => {
                if (res && res.data) {
                    this.profileInfo = res?.data;
                }
            });
        }
        // else if (this.activeTab == 'marketplace') {
        //     this.httpService.sendGetRequest(URLUtils.relationshipMarketplaceProfile(this.reldata)).subscribe((res: any) => {
        //         if (res && res.data) {
        //             this.profileInfo = res?.data;
        //         }
        //     });
        // }
        else {
            this.spinnerService.show();
            this.httpService.sendGetRequest(URLUtils.relationshipExchangeInfoProfile(this.reldata)).subscribe((res: any) => {
                this.spinnerService.hide();
                this.profileInfo = res?.data;
                // console.log('Relationship Data:', this.reldata);
                // console.log('profileInfo Tab:', this.profileInfo);
                // console.log('isEntityProfile Tab:', this.isEntityProfile);
                // console.log('showExchange:', this.showExchange);
                // console.log('primaryCitizen:', this.primaryCitizen);
            });
        }

        this.documentsClick();
        this.docssharedbyus();
        //console.log('Category:', this.category);
    } 
    
    scrollToHighlightedDoc() {
        setTimeout(() => {
            const index = this.docsSharedwithus.findIndex(
                (d: any) => d.isHighlighted
            );

            if (index !== -1) {
                const row = this.docRows.toArray()[index];
                row?.nativeElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }, 0);
    }

    back(){
        // this.showExchange = false;
        // this.event.emit(this.showExchange)
        this.event.emit('exchange-close')
    }
    handleNotificationFlow(ctx: NotificationContext) {  
      if (ctx.highlight_ids?.length) { 
        this.highlightSet = new Set(ctx.highlight_ids);
        this.currentTab = "documents"
      }  
    }
    getMatterNames(doc: any): string {
        return doc.matter_details?.map((item:any) => item.name).join(', ');
      }

    documentsClick() {
        if ((this.activeTab == 'corporate' || this.activeTab == 'marketplace') || environment.product == 'corporate') {
            this.httpService.sendGetRequest(URLUtils.relationshipDocsSharedwithusCorp(this.reldata)).subscribe((res: any) => {
                if (res && res.documents){
                    if(this.reldata.clientType == 'Entity'){
                        this.docsSharedwithus = res?.documents?.general;
                    }
                    if(this.reldata.clientType == 'Consumer'){
                        let identity: any[] = []; 
                        let personal: any[] = []; 
                        identity = res?.documents?.identity;
                        personal = res?.documents?.personal;
                        this.docsSharedwithus = identity.concat(personal)
                    } 
                  this.docsSharedwithus = this.docsSharedwithus.map((item: any) => ({
                    ...item,
                    isHighlighted: this.highlightSet.has(item.id)
                  })); 
                  this.scrollToHighlightedDoc(); 
                  //console.log('Highlighted Items:', this.docsSharedwithus.filter((item: any) => item.isHighlighted));
                }
                else {
                    this.toast.error(res.msg);
                }
            });

        } else {

            this.httpService.sendGetRequest(URLUtils.relationshipDocsSharedwithus(this.reldata)).subscribe((res: any) => {
                if (res && res.documents){
                    if(this.reldata.clientType == 'Entity'){
                        this.docsSharedwithus = res?.documents?.general;
                    }
                    if(this.reldata.clientType == 'Consumer'){
                        let identity: any[] = []; 
                        let personal: any[] = []; 
                        identity = res?.documents?.identity;
                        personal = res?.documents?.personal;
                        this.docsSharedwithus = identity.concat(personal)
                    } 
                  this.docsSharedwithus = this.docsSharedwithus.map((item: any) => ({
                    ...item,
                    isHighlighted: this.highlightSet.has(item.id)
                  })); 
                  this.scrollToHighlightedDoc(); 
                  //console.log('Highlighted Items:', this.docsSharedwithus.filter((item: any) => item.isHighlighted));
                }
                else {
                    this.toast.error(res.msg);
                }
            });

        }
       
    }
    docssharedbyus() {

        if (this.activeTab == 'corporate' || environment.product == 'corporate'){

            this.httpService.sendGetRequest(URLUtils.relationshipDocsSharedbyusCorp(this.reldata)).subscribe((res: any) => {
                if (res && res.documents){
                    this.docsSharedbyus = res?.documents?.general;
                }
                else {
                    this.toast.error(res.msg);
                }
            });
    
            this.httpService.sendPutRequest(URLUtils.getFilteredDocuments,
                {"category":"client", "clients": this.clientId , "matters":"all", "relationship_id": this.reldata.id, "exclude_already_shared": true}).subscribe(
                (res: any) => {
                    this.clientDocuments = res?.data;
                    this.mergeClientandFirmDoc();
            },
            (error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                  const errorMessage = error.error.msg || 'Unauthorized';
                  this.toast.error(errorMessage);
                  //console.log(error);
                }
              }
            )

            
            var payload 
            payload = {"category":"firm", "groups": this.grp_acls}
            if(this.product=='corporate'){
                const matt = this.matterList.map(item => item.matterId)
                payload = {"category":"firm", "groups": this.grp_acls , "type":"corporate","subcategories":matt}

            }
            this.httpService.sendPutRequest(URLUtils.getFilteredDocuments,payload
                ).subscribe(
                (res: any) => {
                    this.firmDocuments = res?.data;
                    this.mergeClientandFirmDoc();
            },
            (error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                  const errorMessage = error.error.msg || 'Unauthorized';
                  this.toast.error(errorMessage);
                  //console.log(error);
                }
              }
            )
            // this.httpService.sendGetRequest(URLUtils.getFirmDocuments).subscribe((res: any) => {
            //     this.firmDocuments = res?.docs;
            //     this.mergeClientandFirmDoc();
            // });
            this.sharedandUnsharedData = { 'add': [], 'remove': [], 'message': "" };

        } 
        else if (this.activeTab == 'marketplace'){

            this.httpService.sendGetRequest(URLUtils.relationshipDocsSharedbyusCorp(this.reldata)).subscribe((res: any) => {
                if (res && res.documents){
                    this.docsSharedbyus = res?.documents?.general;
                }
                else {
                    this.toast.error(res.msg);
                }
            });
    
            this.httpService.sendPutRequest(URLUtils.getFilteredDocuments,
                {"category":"client", "matters":"all", "relationship_id": this.reldata.id, "exclude_already_shared": true}).subscribe(
                (res: any) => {
                    this.clientDocuments = res?.data;
                    this.mergeClientandFirmDoc();
            },
            (error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                  const errorMessage = error.error.msg || 'Unauthorized';
                  this.toast.error(errorMessage);
                  //console.log(error);
                }
              }
            )

            
            var payload 
            payload = {"category":"firm", "groups": this.grp_acls}
            if(this.product=='corporate'){
                const matt = this.matterList.map(item => item.matterId)
                payload = {"category":"firm", "groups": this.grp_acls , "type":"corporate","subcategories":matt}

            }
            this.httpService.sendPutRequest(URLUtils.getFilteredDocuments,payload
                ).subscribe(
                (res: any) => {
                    this.firmDocuments = res?.data;
                    this.mergeClientandFirmDoc();
            },
            (error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                  const errorMessage = error.error.msg || 'Unauthorized';
                  this.toast.error(errorMessage);
                  //console.log(error);
                }
              }
            )
            // this.httpService.sendGetRequest(URLUtils.getFirmDocuments).subscribe((res: any) => {
            //     this.firmDocuments = res?.docs;
            //     this.mergeClientandFirmDoc();
            // });
            this.sharedandUnsharedData = { 'add': [], 'remove': [], 'message': "" };

        } 
        else {
            //console.log('L product')
            this.httpService.sendGetRequest(URLUtils.relationshipDocsSharedbyus(this.reldata)).subscribe((res: any) => {
                if (res && res.documents && !res.error){
                    this.docsSharedbyus = res?.documents?.general;
                }
                else {
                    this.toast.error(res.msg);
                }
            });
    
            this.httpService.sendPutRequest(URLUtils.getFilteredDocuments,
                {"category":"client", "clients": this.clientId , "matters":"all", "relationship_id": this.reldata.id, "exclude_already_shared": true }).subscribe(
                (res: any) => {
                    this.clientDocuments = res?.data;
                    this.mergeClientandFirmDoc();
            },
            (error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                  const errorMessage = error.error.msg || 'Unauthorized';
                  this.toast.error(errorMessage);
                  //console.log(error);
                }
              }
            )
    
            this.httpService.sendPutRequest(URLUtils.getFilteredDocuments,
                {"category":"firm", "groups": this.grp_acls}).subscribe(
                (res: any) => {
                    this.firmDocuments = res?.data;
                    this.mergeClientandFirmDoc();
                   
            },
            (error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                  const errorMessage = error.error.msg || 'Unauthorized';
                  this.toast.error(errorMessage);
                  //console.log(error);
                }
              }
            )
            // this.httpService.sendGetRequest(URLUtils.getFirmDocuments).subscribe((res: any) => {
            //     this.firmDocuments = res?.docs;
            //     this.mergeClientandFirmDoc();
            // });
            this.sharedandUnsharedData = { 'add': [], 'remove': [], 'message': "" };

        }
        
    }
    mergeClientandFirmDoc() {
        this.allDocs = [];
        let cdocs: any[] = [];
        let fdocs: any[] = [];
        let sharedIds = this.docsSharedbyus.map((obj: any) => { return obj.id})
        this.clientDocuments.forEach((item: any, index: number) => {
            if(sharedIds.indexOf(item.id) == -1){
                cdocs.push(item)
            }
        })
        this.firmDocuments.forEach((item: any, index: number) => {
            if(sharedIds.indexOf(item.id) == -1){
                fdocs.push(item)
            }
        })
        this.clientDocuments = cdocs
        this.firmDocuments = fdocs
        this.allDocs = this.allDocs.concat(this.clientDocuments);
        this.allDocs = this.allDocs.concat(this.firmDocuments);
    }

    onReset() {
        this.isConformation = false;
        this.sharedandUnsharedData.remove = [];
        this.sharedandUnsharedData.add = [];
        this.docssharedbyus();
        //this.toast.error('Documents Not selected!');
    }
    onConfirmReset() {
        this.isConformation = false;
    }
    // unShare(doc: any) {
    //     doc['highlight'] = true
    //     console.log('doc:', doc);
    //     console.log('doc:', this.category);
    //     this.sharedandUnsharedData.remove.push(doc);
    //     let i = this.sharedandUnsharedData.add.findIndex((d: any) => d.id === doc.id); //find index in your array
    //     if (i > -1) {
    //         this.sharedandUnsharedData.add.splice(i, 1);
    //     }
    //     //Old one!
    //     //doc.category == 'firm' ? this.firmDocuments.push(doc) : this.clientDocuments.push(doc);
    //     //New one for corporate and other products!
    //     if (this.product == 'corporate') {
    //         //doc.category == 'firm' ? this.firmDocuments.push(doc) : this.clientDocuments.push(doc);
    //         doc.category == 'client' ? this.clientDocuments.push(doc) : this.firmDocuments.push(doc);
    //     }
    //     if (this.product != 'corporate') {
    //         doc.category == 'firm' ? this.firmDocuments.push(doc) : this.clientDocuments.push(doc);
    //         doc.category == 'client' ? this.clientDocuments.push(doc) : this.firmDocuments.push(doc);
    //     }
    //     console.log('doc.category:', doc?.category);
    //     // console.log('Client result:', doc?.category === 'client');
    //     // console.log('Firm result:', doc?.category === 'firm')
    //     let index = this.docsSharedbyus.findIndex((d: any) => d.id === doc.id); //find index in your array
    //     this.docsSharedbyus.splice(index, 1);
    // }

    unSharex(doc: any,type: string) {
        doc['highlight'] = true
        this.sharedandUnsharedData.remove.push(doc);
        let i = this.sharedandUnsharedData.add.findIndex((d: any) => d.id === doc.id); //find index in your array
        if (i > -1) {
            this.sharedandUnsharedData.add.splice(i, 1);
        }
        
        if (this.product == 'corporate') {
            //doc.category == 'client' ? this.clientDocuments.push(doc) : this.firmDocuments.push(doc);
            let index = this.firmDocuments.findIndex((d: any) => d.id === doc.id); //find index in your array
            this.firmDocuments.push(doc);
        }
        if (this.product != 'corporate') {
            if (type == 'client') {
                let index = this.clientDocuments.findIndex((d: any) => d.id === doc.id); //find index in your array
                this.clientDocuments.push(doc);
            } else {
                let index = this.firmDocuments.findIndex((d: any) => d.id === doc.id); //find index in your array
                this.firmDocuments.push(doc);
            }
        }
        let index = this.docsSharedbyus.findIndex((d: any) => d.id === doc.id); //find index in your array
        this.docsSharedbyus.splice(index, 1);
    }

    share(doc: any, type: string) {
        doc['highlight'] = true
        this.sharedandUnsharedData.add.push(doc);
        this.docsSharedbyus.push(doc);
        let index = this.sharedandUnsharedData.remove.findIndex((d: any) => d.id === doc.id); //find index in your array
        if(index > -1){
            this.sharedandUnsharedData.remove.splice(index, 1);
        }
        if (type == 'client') {
            let index = this.clientDocuments.findIndex((d: any) => d.id === doc.id); //find index in your array
            this.clientDocuments.splice(index, 1);
        } else {
            let index = this.firmDocuments.findIndex((d: any) => d.id === doc.id); //find index in your array
            this.firmDocuments.splice(index, 1);
        }
    }
    shareClick() {
        this.isConformation = !this.isConformation;
        let val = [...this.sharedandUnsharedData.add, ...this.sharedandUnsharedData.remove];
        this.unchangedDocs = this.docsSharedbyus.filter((el: any) => {
            return !val.find((element: any) => {
                return element.id === el.id;
            });
        });
    }
    updateMatters(doc: any, selectedMatters: any[]) {
        if(doc){

            this.sharedandUnsharedData.add.forEach((item: any) => {
                if (item.id === doc.id) {
                    item.matters = selectedMatters.map((matter: any) => matter.matterId);
                }
            });

        }
        
    }    


    updateShareandUnshareDoc() {

        // console.log('msg',this.message)
        // console.log('profileInfo',this.profileInfo)
        // console.log('sharedandUnsharedData',this.sharedandUnsharedData)

        if ((this.activeTab == 'corporate' || this.activeTab == 'marketplace') || environment.product == 'corporate'){
            let data = {
                'add': this.sharedandUnsharedData.add.map((obj: any) => ({ "docid": obj.docid, "doctype": "general" ,"matters":obj.matters})),
                'message': this.message,
                'remove': this.sharedandUnsharedData.remove.map((obj: any) => ({ "docid": obj.id, "doctype": "general"})),
                "relid":this.reldata?.id
            }
            this.httpService.sendPostRequest(URLUtils.shareRelationshipDocumentsCorp,data).subscribe((res: any) => {
                if (!res.error) {
                    let aroute = this.aroute
                    // this.confirmationDialogService.confirm('Success',
                    //     'Congratulations!! You have successfully completed document exchange actions with ' + this.profileInfo.fullname,false, '', '', false,"sm", false)
                    //     .then(() => {})

                    let msg = `You have successfully completed document exchange actions with ${this.profileInfo.fullname}`
                    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                        width: '400px',
                        data: { title: 'Congratulations', message: msg, hideButtons: true }
                    });
                    dialogRef.afterClosed().subscribe((result: any) => {
                        if (result) {
                        }
                    });
                   // this.event.emit('exchange-close')
                } else {
                    alert(res.msg);
                }
            },
            (error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                  const errorMessage = error.error.msg || 'Unauthorized';
                  this.toast.error(errorMessage);
                  //console.log(error);
                }
              });
        }
        else if(this.activeTab == 'individuals') {
            let fullname = this.profileInfo.first_name + ' ' + this.profileInfo.last_name
            //console.log('this.profileInfo',fullname)

            let data = {
                'add': this.sharedandUnsharedData.add.map((obj: any) => ({ "docid": obj.docid, "doctype": "general" ,"matters":obj.matters})),
                'message': this.message,
                'remove': this.sharedandUnsharedData.remove.map((obj: any) => ({ "docid": obj.id, "doctype": "general" })),
            }
            this.httpService.sendPutRequest(URLUtils.shareRelationshipDocuments(this.reldata), data).subscribe((res: any) => {
                if (!res.error) {
                    let aroute = this.aroute
                    // this.confirmationDialogService.confirm('Success',
                    //     'Congratulations!! You have successfully completed document exchange actions with ' + fullname ,false, '', '', false,"sm", false)
                    //     .then(() => {})
                          
                    //console.log('profname',this.profileInfo)
                    let msg = `You have successfully completed document exchange actions with ${this.profileInfo.first_name} ${this.profileInfo.last_name}`
                    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                        width: '400px',
                        data: { title: 'Congratulations', message: msg, hideButtons: true }
                    });
                    dialogRef.afterClosed().subscribe((result: any) => {
                        if (result) {
                        }
                    });
                    //this.event.emit('exchange-close')
                } else {
                    alert(res.msg);
                }
            },
            (error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                  const errorMessage = error.error.msg || 'Unauthorized';
                  this.toast.error(errorMessage);
                  //console.log(error);
                }
              });
        }
        else {
            let data = {
                'add': this.sharedandUnsharedData.add.map((obj: any) => ({ "docid": obj.docid, "doctype": "general" ,"matters":obj.matters})),
                'message': this.message,
                'remove': this.sharedandUnsharedData.remove.map((obj: any) => ({ "docid": obj.id, "doctype": "general" })),
            }
            this.httpService.sendPutRequest(URLUtils.shareRelationshipDocuments(this.reldata), data).subscribe((res: any) => {
                if (!res.error) {
                    let aroute = this.aroute
                    // this.confirmationDialogService.confirm('Success',
                    //     'Congratulations!! You have successfully completed document exchange actions with ' + this.profileInfo.fullname,false, '', '', false,"sm", false)
                    //     .then(() => {})
                                        
                    let msg = `You have successfully completed document exchange actions with ${this.profileInfo.fullname}`
                    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                        width: '400px',
                        data: { title: 'Congratulations', message: msg, hideButtons: true }
                    });
                    dialogRef.afterClosed().subscribe((result: any) => {
                        if (result) {
                        }
                    });
                    //this.event.emit('exchange-close')
                } else {
                    alert(res.msg);
                }
            },
            (error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                  const errorMessage = error.error.msg || 'Unauthorized';
                  this.toast.error(errorMessage);
                  //console.log(error);
                }
              });
        }
        
    }
    copyWithmeDoc(doc: any) {
        let args = {'relId': this.reldata.id, 'docid': doc.id }
        this.confirmationDialogService.confirm('Confirm', 'Are you sure! You want to copy ' + doc.name,true, 'Yes', 'No')
        //this.confirmationDialogService.confirm('Confirm', ' Are you sure! Do you want to copy!', true, 'Yes', 'No')
            .then((confirmed) => {
                if (confirmed) {
                    this.httpService.sendGetRequest(URLUtils.relationshipCopyDoc(args)).subscribe((res: any) => {
                        if(res.error){
                            this.confirmationDialogService.confirm('Error', res.msg,true, "Ok", "Close", false,"sm");
                        }
                        if(!res.error){
                            this.confirmationDialogService.confirm('Success', res.msg,true, "Ok", "Close", false,"sm");
                        }
                    });
                }
            }).catch(() => {});
    }
    viewDocument(item: any) {
        if (item.added_encryption) {
            const body = new FormData();
            body.append('docid', item.docid);
            body.append('shared_doc', true.toString());
            const url = environment.apiUrl + URLUtils.decryptFile;

            this.httpService.sendPostDecryptRequest(url, body).subscribe((res: any) => {
                const blob = new Blob([res], { type: item.content_type });
                const blobUrl = URL.createObjectURL(blob);

                if (this.allowedFileTypes.includes(item.content_type)) {
                    const fdata = new FormData();
                    fdata.append('file', blob);
                    this.httpService.sendPostDecryptRequest(environment.DOC2FILE, fdata).subscribe((ans: any) => {
                        const ansBlob = new Blob([ans], { type: 'application/pdf' });
                        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(ansBlob));
                        this.confirmationDialogService.confirm('View', { isIframe: true, url: this.urlSafe }, true, 'Ok', 'Close', false, 'lg');
                    });
                } else {
                    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
                    this.confirmationDialogService.confirm('View', { isIframe: true, url: this.urlSafe }, true, 'Ok', 'Close', false, 'lg');
                }
            });
        }

        if (item.added_encryption === false) {
            this.httpService.sendGetRequest(URLUtils.viewDocuments({ id: item.docid })).subscribe((res: any) => {
                if (this.allowedFileTypes.includes(item.content_type)) {
                    this.spinnerService.show();
                    this.httpService.sendPostDocRequest(this.docapi, { url: res.data.url }).subscribe((ans: any) => {
                        const blob = new Blob([ans], { type: 'application/pdf' });
                        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
                        this.confirmationDialogService.confirm('View', { isIframe: true, url: this.urlSafe }, true, 'Ok', 'Close', false, 'lg');
                        this.spinnerService.hide();
                    });
                } else {
                    if (res && res.data && !res.error) {
                        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.url);
                        this.confirmationDialogService.confirm('View', { isIframe: true, url: this.urlSafe }, true, 'Ok', 'Close', false, 'lg');
                    } else {
                        alert(res.msg);
                    }
                }
            });
        }
    }

    viewGenDoc(item: any) {
        //console.log('view item',item)
        let args = {
            'relId': this.reldata.id,
            'docid': item.id
        }

        if(item.added_encryption){
           
            var body = new FormData();
            body.append('docid', item.id)
            let url = environment.apiUrl + URLUtils.decryptFile
            this.httpService.sendPostDecryptRequest(url,body).subscribe((res:any)=>{
                this.spinnerService.show()
                const blob = new Blob([res], { type: item.content_type });
                const url = URL.createObjectURL(blob);
                if(this.allowedFileTypes.includes(item.content_type)){
                    let fdata = new FormData();
                    fdata.append('file', blob);
                    this.httpService.sendPostDecryptRequest(environment.DOC2FILE,fdata).subscribe((ans:any)=>{
                        const ansBlob = new Blob([ans], { type: 'application/pdf' });
                        const ansUrl = URL.createObjectURL(ansBlob);
                        // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(ansUrl)
                        // let obj = {
                        //     'isIframe': true,
                        //     'url': this.urlSafe
                        // }
                        //this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
                         this.previewDocument = {
                            name: item.name,
                            mimeType: item.content_type,
                            previewUrl: this.sanitizer.bypassSecurityTrustResourceUrl(ansUrl)
                        };
                        this.isPreviewOpen = true;   // ✅ OPEN YOUR MODAL
                        this.spinnerService.hide()
                    })

                } else {
                    // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url)
                    // let obj = {
                    //     'isIframe': true,
                    //     'url': this.urlSafe
                    // }
                    //this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
                     this.previewDocument = {
                            name: item.name,
                            mimeType: item.content_type,
                            previewUrl: this.sanitizer.bypassSecurityTrustResourceUrl(url)
                        };
                        this.isPreviewOpen = true;   // ✅ OPEN YOUR MODAL
                    this.spinnerService.hide()
                }   
              
            })
            this.spinnerService.hide()
        } 
        else if(item.added_encryption === false) {
            var body = new FormData();
            body.append('docid', item.id)
            
            this.httpService.sendGetRequest(URLUtils.viewDocuments({ id: item.id })).subscribe((res: any) => {
                if (this.allowedFileTypes.includes(item.content_type)) {
                    this.spinnerService.show();
                    this.httpService.sendPostDocRequest(this.docapi, { url: res.data.url }).subscribe((ans: any) => {
                        const blob = new Blob([ans], { type: 'application/pdf' });
                        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
                        this.confirmationDialogService.confirm('View', { isIframe: true, url: this.urlSafe }, true, 'Ok', 'Close', false, 'lg');
                        this.spinnerService.hide();
                    });
                } else {
                    if (res && res.data && !res.error) {
                        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.url);
                        this.confirmationDialogService.confirm('View', { isIframe: true, url: this.urlSafe }, true, 'Ok', 'Close', false, 'lg');
                    } else {
                        alert(res.msg);
                    }
                }
            });
        }
        else {
            this.httpService.sendGetRequest(URLUtils.viewDocuments(item)).subscribe((res: any) => {
                if(this.allowedFileTypes.includes(item.content_type)){
                    this.spinnerService.show()
                    this.httpService.sendPostDocRequest(environment.doc2pdf,{'url':res.data.url}).subscribe((ans:any)=>{
                        const blob = new Blob([ans], { type: 'application/pdf' });
                        // Create a URL for the Blob
                        const url = URL.createObjectURL(blob);
                        // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url)
                        // let obj = {
                        //     'isIframe': true,
                        //     'url': this.urlSafe
                        // }
                        // this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
                         this.previewDocument = {
                            name: item.name,
                            mimeType: item.content_type,
                            previewUrl: this.sanitizer.bypassSecurityTrustResourceUrl(url)
                        };
                        this.isPreviewOpen = true;   // ✅ OPEN YOUR MODAL
                        this.spinnerService.hide()
                    })
                    
    
                } else {
                    if (res && !res.error) {
                        // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.url);
                        // let obj = {
                        //     'isIframe': true,
                        //     'url': this.urlSafe
                        // }
                        // this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
                           this.previewDocument = {
                            name: item.name,
                            mimeType: item.content_type,
                            previewUrl: this.sanitizer.bypassSecurityTrustResourceUrl(res.data.url)
                        };
                        this.isPreviewOpen = true;   // ✅ OPEN YOUR MODAL
                    }
                    else {
                        alert(res.msg)
                    }
                }
                
                //console.log(" this.view    " + JSON.stringify(this.documents));
            });
        }
        // if (this.activeTab == 'corporate' || environment.product == 'corporate'){

        //     this.httpService.sendGetRequest(URLUtils.relationshipViewDocCorp(args)).subscribe((res: any) => {
        //         if (res && !res.error) {
        //             this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(res.url);
        //             let obj = {
        //                 'isIframe': true,
        //                 'url': this.urlSafe
        //             }
        //             this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
        //         }
        //         else {
        //             alert(res.msg)
        //         }
        //     });

        // } else {

        //     this.httpService.sendGetRequest(URLUtils.relationshipViewDoc(args)).subscribe((res: any) => {
        //         if (res && !res.error) {
        //             this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(res.url);
        //             let obj = {
        //                 'isIframe': true,
        //                 'url': this.urlSafe
        //             }
        //             this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
        //         }
        //         else {
        //             alert(res.msg)
        //         }
        //     });

        // }
        
    }

    viewDoc(item: any) {
        console.log('vv item',item)
        console.log('profInfo',this.profileInfo)

        let args = {
            'relId': this.reldata.id,
            'docid': item.id
        }
       
        if(item.added_encryption){
           
            var body = new FormData();
            body.append('docid', item.id)
            body.append('shared_doc',true.toString())
            // body.append('uid',this.profileInfo.uid)
            let url = environment.apiUrl + URLUtils.decryptFile
            this.httpService.sendPostDecryptRequest(url,body).subscribe((res:any)=>{
                this.spinnerService.show()
                const blob = new Blob([res], { type: item.content_type });
                const url = URL.createObjectURL(blob);

                if(this.allowedFileTypes.includes(item.content_type)){
                    let fdata = new FormData();
                    fdata.append('file', blob);
                    this.httpService.sendPostDecryptRequest(environment.DOC2FILE,fdata).subscribe((ans:any)=>{
                        const ansBlob = new Blob([ans], { type: 'application/pdf' });
                        const ansUrl = URL.createObjectURL(ansBlob);
                        // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(ansUrl)
                        // let obj = {
                        //     'isIframe': true,
                        //     'url': this.urlSafe
                        // }
                        this.previewDocument = {
                            name: item.name,
                            mimeType: item.content_type,
                            previewUrl: this.sanitizer.bypassSecurityTrustResourceUrl(url)
                        };
                        this.isPreviewOpen = true;   // ✅ OPEN YOUR MODAL
                       // this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
                        this.spinnerService.hide()
                    })

                } else {
                    // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url)
                    // let obj = {
                    //     'isIframe': true,
                    //     'url': this.urlSafe
                    // }
                    this.previewDocument = {
                        name: item.name,
                        mimeType: item.content_type,
                        previewUrl: this.sanitizer.bypassSecurityTrustResourceUrl(res.url)
                    };
                    this.isPreviewOpen = true;   // ✅ OPEN YOUR MODAL
                    //this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
                    this.spinnerService.hide()
                }   
              
            })
            this.spinnerService.hide()
        }         
        else if(item.added_encryption === false) {
            var body = new FormData();
            body.append('docid', item.id)
            
            this.httpService.sendGetRequest(URLUtils.viewDocuments({ id: item.id })).subscribe((res: any) => {
                if (this.allowedFileTypes.includes(item.content_type)) {
                    this.spinnerService.show();
                    this.httpService.sendPostDocRequest(this.docapi, { url: res.data.url }).subscribe((ans: any) => {
                        const blob = new Blob([ans], { type: 'application/pdf' });
                        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
                        this.confirmationDialogService.confirm('View', { isIframe: true, url: this.urlSafe }, true, 'Ok', 'Close', false, 'lg');
                        this.spinnerService.hide();
                    });
                } else {
                    if (res && res.data && !res.error) {
                        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.url);
                        this.confirmationDialogService.confirm('View', { isIframe: true, url: this.urlSafe }, true, 'Ok', 'Close', false, 'lg');
                    } else {
                        alert(res.msg);
                    }
                }
            });
        }
        else {
            this.httpService.sendGetRequest(URLUtils.viewDocuments(item)).subscribe((res: any) => {
                if(this.allowedFileTypes.includes(item.content_type)){
                    this.spinnerService.show()
                    this.httpService.sendPostDocRequest(environment.doc2pdf,{'url':res.data.url}).subscribe((ans:any)=>{
                        const blob = new Blob([ans], { type: 'application/pdf' });
                        // Create a URL for the Blob
                        const url = URL.createObjectURL(blob);
                        // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url)
                        // let obj = {
                        //     'isIframe': true,
                        //     'url': this.urlSafe
                        // }
                        // this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
                                                
                        this.previewDocument = {
                            name: item.name,
                            mimeType: item.content_type,
                            previewUrl: this.sanitizer.bypassSecurityTrustResourceUrl(res.url)
                        };
                        this.isPreviewOpen = true;   // ✅ OPEN YOUR MODAL
                        this.spinnerService.hide()
                    })
                    
    
                } else {
                    if (res && !res.error) {
                        // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.url);
                        // let obj = {
                        //     'isIframe': true,
                        //     'url': this.urlSafe
                        // }
                        // this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
                        this.previewDocument = {
                            name: item.name,
                            mimeType: item.content_type,
                            previewUrl: this.sanitizer.bypassSecurityTrustResourceUrl(res.url)
                        };
                        this.isPreviewOpen = true;   // ✅ OPEN YOUR MODAL
                    }
                    else {
                        alert(res.msg)
                    }
                }
                
                //console.log(" this.view    " + JSON.stringify(this.documents));
            });
        }
        // if (this.activeTab == 'corporate' || environment.product == 'corporate'){

        //     this.httpService.sendGetRequest(URLUtils.relationshipViewDocCorp(args)).subscribe((res: any) => {
        //         if (res && !res.error) {
        //             this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(res.url);
        //             let obj = {
        //                 'isIframe': true,
        //                 'url': this.urlSafe
        //             }
        //             this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
        //         }
        //         else {
        //             alert(res.msg)
        //         }
        //     });

        // } else {

        //     this.httpService.sendGetRequest(URLUtils.relationshipViewDoc(args)).subscribe((res: any) => {
        //         if (res && !res.error) {
        //             this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(res.url);
        //             let obj = {
        //                 'isIframe': true,
        //                 'url': this.urlSafe
        //             }
        //             this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
        //         }
        //         else {
        //             alert(res.msg)
        //         }
        //     });

        // }
        
    }

    viewDocShared(item:any){
        console.log('item',item)
        console.log('reldata',this.reldata)
        
        let args = {
            'relId': this.reldata.id,
            'docid': item.id
        }

        if(item.doctype=='general'){
            this.viewDoc(item)
        } 
        else 
        {
            this.httpService.sendGetRequest(URLUtils.relationshipViewDoc(args)).subscribe((res: any) => {
                
            this.isLoading = true;   // ✅ show spinner

                if(this.allowedFileTypes.includes(item.content_type)){
                    this.spinnerService.show()
                    this.httpService.sendPostDocRequest(environment.doc2pdf,{'url':res.url}).subscribe((ans:any)=>{
                        const blob = new Blob([ans], { type: 'application/pdf' });
                        // Create a URL for the Blob
                        const url = URL.createObjectURL(blob);
                         
                        this.previewDocument = {
                            name: item?.name,
                            mimeType: 'application/pdf',
                            previewUrl: this.sanitizer.bypassSecurityTrustResourceUrl(url)
                        };
                        this.isPreviewOpen = true;   // ✅ OPEN YOUR MODAL

                        // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url)
                        // let obj = {
                        //     'isIframe': true,
                        //     'url': this.urlSafe
                        // }
                        //this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
                        this.spinnerService.hide()
                    })
                    
    
                } else {
                    if (res && !res.error) {
                        // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(res.url);
                        // let obj = {
                        //     'isIframe': true,
                        //     'url': this.urlSafe
                        // }
                        // this.urlSafe.bypassSecurityTrustResourceUrl(res.data?.url);  
                        // //this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");

                        this.previewDocument = {
                            name: item.name,
                            mimeType: item.content_type,
                            previewUrl: this.sanitizer.bypassSecurityTrustResourceUrl(res.url)
                        };
                        this.isPreviewOpen = true;   // ✅ OPEN YOUR MODAL
                    }
                    else {
                        alert(res.msg)
                    }
                }
            });
        } 

    } 

    isImage(mimeType: any): any {
        return this.IMAGE_MIME_TYPES.has(mimeType);
    }
    openPreview(document: Document): void {
        this.previewDocument = document;
        this.isPreviewOpen = true;
        //console.log('previewDocument', this.previewDocument);
    }
    onPreviewLoad(): void {
        setTimeout(() => {
            this.isLoading = false;
        }, 500)
    }
    closePreview(): void {
        if (this.previewDocument) {
            URL.revokeObjectURL(this.previewDocument.toString());
        }
        this.previewDocument = null;
        this.isPreviewOpen = false;
    }


    // viewDoc(item: any){
    //     console.log(item)
    //     this.httpService.sendGetRequest(URLUtils.viewDocuments({"id": item?.id})).subscribe((res: any) => {
    //         if (res && !res.error) {
    //             this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.url);
    //             let obj = {
    //                 'isIframe': true,
    //                 'url': this.urlSafe
    //             }
    //             this.confirmationDialogService.confirm('View', obj,true, "Ok", "Close", false,"lg");
    //         }
    //         else {
    //             alert(res.msg)
    //         }
    //     });
    // }
    
     sort(property: any, docsShared: any) {
        let docs = docsShared;
        this.isDesc = !this.isDesc; //change the direction    
        // this.column = property;
        let direction = this.isDesc ? 1 : -1;
        docs.sort(function (a: any, b: any) {
            if (a[property] < b[property]) {
                return -1 * direction;
            }
            else if (a[property] > b[property]) {
                return 1 * direction;
            }
            else {
                return 0;
            }
        });
     };
    
        sortingFile(val: any) {
            this.isReverse = !this.isReverse;
            if (this.isReverse) {
                this.documents = this.documents?.sort((p1: any, p2: any) => (p1[val] < p2[val]) ? 1 : (p1[val] > p2[val]) ? -1 : 0);
            } else {
                this.documents = this.documents?.sort((p1: any, p2: any) => (p1[val] > p2[val]) ? 1 : (p1[val] < p2[val]) ? -1 : 0);
            }
        }

    
    cancel() {
        this.event.emit('exchange-close')
        }

    getPhoneNumber(): string {
        const phone = this.isEntityProfile
            ? this.profileInfo?.contact_phone
            : this.profileInfo?.mobile;
        return phone && phone.trim() ? phone : 'N/A';
    }
    get primaryCitizen() {
        return this.profileInfo?.citizen?.find(
            (c: any) => c.index === 'citizen_primary'
        );
    }
       
    /**
                 this.confirmationDialogService.confirm('Confirm', 'Changes you made will not be saved. Do you want to continue?' ,true, 'Yes', 'No')
                .then((confirmed) => {
                    if (confirmed) {
                        
                    }
                    else{
                        this.event.emit('exchange-close')
                    }
                }).catch(() => {});
     */

                  
    goBacktoConnections() {
        this.profileKey = false;
        this.toggleDetails();
    }

    chatProfile() {
        this.router.navigate(['/chats']);
    }

    toggleDetails() {
        this.showDetails = !this.showDetails;
        // this.httpService.sendGetRequest(URLUtils.relationshipExchangeInfoProfile(this.reldata)).subscribe((res: any) => {
        //     this.profileInfo = res?.data;
        // });
    }


      getCountries() {
    // this.httpService.getCountries().subscribe((res: any) => {
    //   this.country = res.data.country;
    // });
  }

    getCountryCode(countryName: any): string {
        if (!countryName || typeof countryName !== 'string') {
            return '';
        }

        const name = countryName.trim();

        if (!name) {
            return '';
        }

        const code = this.countryCodeMap[name];

        if (!code) {
            console.warn(`Missing country code for: ${name}`);
        }

        return code || '';
    }

    getFlagUrl(countryName: any): string {
        const code = this.getCountryCode(countryName);

        return code ? `https://flagcdn.com/${code.toLowerCase()}.svg` : '';
    }

    shareDocuments(category?: any) {
       // console.log('sharecat', category)
        const dialogRef = this.dialog.open(ShareDocumentsDialogComponent, {
            width: '550px',
            height: '400px',
            panelClass: 'document-dialog',
            disableClose: true,
            hasBackdrop: true,
            backdropClass: 'backdropBackground',
            data: {
                mode: 'add',
                category: 'client',
                name: this.isEntityProfile ? this.profileInfo.fullname : `${this.profileInfo.first_name} ${this.profileInfo.last_name}`,
                id: this.reldata?.client_id || '',
                relid: this.reldata?.id
            }
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (!result) return;

            // console.log('Received from Share:', result);

            // store selected docs
            this.sharedandUnsharedData.add = result.selectedDocs.map((doc: any) => ({
                docid: doc.docid,
                doctype: doc.doctype,
                matters: doc.matters
            }));
            //console.log('Received shhhhh:', this.sharedandUnsharedData);
            this.sharedandUnsharedData.remove = []; //rem id while sharing
            this.updateShareandUnshareDoc(); //sharing docs based on conditions
            this.docssharedbyus(); //get docs
            // this.resetShareData();
        });
    }

    //   resetShareData() {
    //     this.sharedandUnsharedData = {
    //        // add: [],
    //         remove: []
    //     };
    //     this.message = '';
    // }

  loadFiles(type: 'with' | 'by') {
    //console.log('Loading files for tab:', type);
    this.activeTol = type;

      if (type === 'with') {
          this.documentsClick();
      } else if (type === 'by') {
          this.docssharedbyus();
      }
  }

    onDocumentAction(action: string, document: Document): void {
    switch (action) {
      case 'view':
       // this.viewDocument(document);
        break;
      case 'download':
        //this.downloadDocument(document);
        break;
      // case 'delete':
      //   this.deleteDocument(document);
      //   break;
    }
  }

    unshare(file: any): void {
        //     if (file.doctype === 'identity')
        //       file.docname = this.getReadableDocType(file.docname);
        //   // Open confirmation dialog for unshare action
        //   const confirmationDialogRef = this.dialog.open(ShareconfirmationdialogComponent, {
        //     data: {
        //       document: {
        //         name: file.docname,
        //         id: file.docid,
        //         doctype: file.docname
        //       },
        //       category: file.doctype || 'personal', // Use document type as category
        //       action: 'unshare',
        //       person: {
        //         id: this.selectedProfile.id,
        //         name: this.selectedProfile.business_name,
        //         email: this.selectedProfile.email
        //       },
        //       selectedPeople: [{
        //         id: this.selectedProfile.id,
        //         name: this.selectedProfile.business_name,
        //         email: this.selectedProfile.email,
        //         selected: true,
        //         category: file.doctype || 'personal'
        //       }]
        //     },
        //     width: '500px',
        //     disableClose: true
        //   });

        //   confirmationDialogRef.afterClosed().subscribe(confirmed => {
        //     if (confirmed) {
        //       // User clicked "Stop Sharing" - proceed with unsharing
        //       this.executeUnshare(file);
        //     }
        //     // If "No" was clicked, do nothing
        //   });
}




unShare(doc: any, type: string) {
  this.selectedDoc = doc;
  this.selectedType = type;
  this.isShareDialogOpen = true; //just opening unshare dialog
}

onCancel() {
  this.isShareDialogOpen = false;
  this.selectedDoc = null;
}

confirmUnshare() {
  const doc = this.selectedDoc;
  const type = this.selectedType;

  this.isShareDialogOpen = false;

  doc['highlight'] = true;
  this.sharedandUnsharedData.remove.push(doc);

  let i = this.sharedandUnsharedData.add.findIndex((d: any) => d.id === doc.id);
  if (i > -1) {
    this.sharedandUnsharedData.add.splice(i, 1);
  }

  if (this.product == 'corporate') {
    this.firmDocuments.push(doc);
  } else {
    if (type == 'client') {
      this.clientDocuments.push(doc);
    } else {
      this.firmDocuments.push(doc);
    }
  }

  let index = this.docsSharedbyus.findIndex((d: any) => d.id === doc.id);
  this.docsSharedbyus.splice(index, 1);

  this.selectedDoc = null;
  this.updateShareandUnshareDoc();
}


}


